import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';
import { SurfaceProps } from './types';

const background = jadeTheme.theme.color.background;
const border = jadeTheme.global['corner-radius'];

export const StyledBox = styled.div<SurfaceProps>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? background[backgroundColor] : background.surface};
  border-radius: ${({ borderRadius }) =>
    borderRadius ? border[borderRadius] : border.medium};
  padding: ${({hasPadding}) => hasPadding ? jadeTheme.global.space[250] : '0px'};
  max-width: ${({maxWidth}) => maxWidth ? maxWidth : '100%'};
`;
